import React from 'react';
import { faqs } from '../mock/products';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-amber-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mb-4">
              Preguntas frecuentes
            </h2>
            <p className="text-lg text-amber-900/70">
              Resolvemos tus dudas sobre nuestros productos naturales
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white border border-amber-100 rounded-lg px-6 hover:border-amber-300 transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-amber-950 hover:text-amber-700 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-amber-900/80 pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
